import React, { useEffect }                     from 'react'
import axios                                    from 'axios'
import { CLIENT_PUBLIC_TOKEN }                  from '../../config'
import { node_server }                          from '../../Helpers'
import PropTypes                                from 'prop-types'

const GetMalformedUsernamesComponent = ( { setNumMalformedUsers } ) => {

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'admin/analytics/getMalformedUsernames')
         .then( res => {
            setNumMalformedUsers(res.data.numMalformedUsers)
         } )
         .catch( (error) => {
            console.error(error)
         } )
   }, [] )

   return(
      null
   )
}

GetMalformedUsernamesComponent.propTypes = {
   setNumMalformedUsers:                        PropTypes.func
}

export default GetMalformedUsernamesComponent
